import { createFileRoute } from "@tanstack/react-router";

import React from "react";
import HeadingLayout from "src/components/base/heading-layout";
import { useTranslation } from "react-i18next";
import Stat from "src/components/base/stat";
import { ApiCustomer } from "src/api/api_customer";

/**
 * The properties for {@link Dashboard}
 */
export type DashboardProps = {};

/**
 * The customer dashboard
 */
function Dashboard(props: DashboardProps) {
    const [t] = useTranslation("customer-dashboard");

    const data = Route.useLoaderData();

    return (
        <HeadingLayout heading={t("heading.welcome")}>
            <div className={"grid grid-cols-4 gap-12"}>
                <Stat label={t("label.server-devices")} value={data.total_servers} />
                <Stat label={t("label.client-devices")} value={data.total_clients} />
            </div>
        </HeadingLayout>
    );
}

export const Route = createFileRoute("/_customer/c/dashboard/")({
    component: Dashboard,
    loader: async () => await ApiCustomer.devices.getAll({ offset: 0, limit: 0 }),
});
